import { Link } from "react-router-dom"

import {
    formatExperience,
    formatTitlesShort,
    getLowestServicePrice,
    getPublicServices,
} from "utils/helpers/psychologistUtil"
import { Psychologist } from "utils/interfaces"
import { typeOfAvailability } from "modules/SelectionOfPsychologists/components/Card/utils"
import { formatPrice } from "utils/utils"
import { Text } from "ui-kit/components-branded/Text"
import { CURRENCY } from "utils/constants"

export function PsySnippet({ psy }: { psy: Psychologist }) {
    const price = getLowestServicePrice(getPublicServices(psy.offered_services))
    const availability = typeOfAvailability(psy.available_for_booking)
    const sep = <span className="has-text-dark-60">&bull;</span>
    return (
        <div className="mgb-2">
            <Link className="is-underlined color-black-2" to={psy.profile_url}>
                <Text isAccent>{psy.display_name}</Text>
            </Link>{" "}
            <br />
            {formatTitlesShort(psy.titles)} {sep}
            {`Опыт ${formatExperience(psy.experience)}`} {availability && sep}
            {availability} {price && sep}
            {price ? formatPrice(price, CURRENCY.RUB) : undefined}
        </div>
    )
}
